import styled from 'styled-components';
import { Overlay as BPOverlay } from '@blueprintjs/core';
var Overlay = styled(BPOverlay).withConfig({
  displayName: "Takeoverstyles__Overlay",
  componentId: "sc-1yreq3d-0"
})(["width:100%;height:100%;"]);
var Takeover = styled.div.withConfig({
  displayName: "Takeoverstyles__Takeover",
  componentId: "sc-1yreq3d-1"
})(["background:var(--dentsu-color-white);width:100%;height:100%;display:flex;flex-direction:column;"]);
export var Styled = {
  Overlay: Overlay,
  Takeover: Takeover
};